import { useSelector } from "react-redux"
import { useNavigate } from "react-router"

interface ErrorHeaderProps {
    slot?: string
    title?: string
}

export const ErrorHeader = (props: ErrorHeaderProps) => {
    const { title } = props
    return (
        <div className="flex justify-center w-full py-2 text-white bg-error-dark">
            {title ?? 'Perhatian'}
        </div>
    )
}

interface ErrorFormProps {
    slot?: string
    message?: string
}

export const ErrorForm = (props: ErrorFormProps) => {
    const { message } = props
    return (
        <div className="text-center px-16 py-5">
            {message ?? 'Sesi Anda Telah Berakhir, Silahkan Login Kembali'}
        </div>
    )
}

interface ErrorFooterProps {
    slot?: string
}

export const ErrorFooter = (props: ErrorFooterProps) => {
    const { resolve } = useSelector((state: any) => state.dialog.awaitComponentData)
    const handleCancel = () => {
        resolve({})
    }
    return (
        <div className="flex justify-start w-full py-5 px-16">
            <button className="bg-grey-100 hover:bg-grey-200 text-primary-main py-2 w-full" onClick={handleCancel}>Close</button>
        </div>
    )
}